// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountValidatorController from "./account_validator_controller"
application.register("account-validator", AccountValidatorController)

import CommandFormController from "./command_form_controller"
application.register("command-form", CommandFormController)

import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DebouncedValidateController from "./debounced_validate_controller"
application.register("debounced-validate", DebouncedValidateController)

import EmailFormController from "./email_form_controller"
application.register("email-form", EmailFormController)

import EmailsFormController from "./emails_form_controller"
application.register("emails-form", EmailsFormController)

import FencesController from "./fences_controller"
application.register("fences", FencesController)

import FencesCopyController from "./fences_copy_controller"
application.register("fences-copy", FencesCopyController)

import FencesFormController from "./fences_form_controller"
application.register("fences-form", FencesFormController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HistoryController from "./history_controller"
application.register("history", HistoryController)

import IgpsController from "./igps_controller"
application.register("igps", IgpsController)

import ImageFieldController from "./image_field_controller"
application.register("image-field", ImageFieldController)

import InlineFormController from "./inline_form_controller"
application.register("inline-form", InlineFormController)

import LimitedTextFieldController from "./limited_text_field_controller"
application.register("limited-text-field", LimitedTextFieldController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import RemotePaginationController from "./remote_pagination_controller"
application.register("remote-pagination", RemotePaginationController)

import RepairmodalController from "./repairmodal_controller"
application.register("repairmodal", RepairmodalController)

import ResourceModalController from "./resource_modal_controller"
application.register("resource-modal", ResourceModalController)

import TicketPreviewController from "./ticket_preview_controller"
application.register("ticket-preview", TicketPreviewController)

import UpdateCheckController from "./update_check_controller"
application.register("update-check", UpdateCheckController)

import XlsxFormController from "./xlsx_form_controller"
application.register("xlsx-form", XlsxFormController)